module.exports = __webpack_public_path__ + "media/andenes/desnivel_type-0384d9e9.webp";